export default __webpack_public_path__ + "f288e64b92b576284d41d7440748e223.svg";